import WrapperContext from "./wrapper-context.js";
import isObject from "./is-object.js";

class StructCallbackWrapperContext extends WrapperContext {
    constructor(callbacks) {
        super();

        this._callbacks = callbacks;

        this._objectWrapper = new WeakMap();
        this._wrapperObject = new WeakMap();

        const ctx = this;

        this._objectHandler = {
            deleteProperty(object, key) {
                return ctx._propDelete(object, key);
            },

            get(object, key, receiver) {
                return ctx._propGet(object, key);
            },

            has(object, key) {
                return ctx._propHas(object, key);
            },

            set(object, key, value, receiver) {
                return ctx._propSet(object, key, value);
            },
        };

        this._arrayHandler = {
            deleteProperty(object, key) {
                return ctx._propDelete(object, key);
            },

            get(object, key, receiver) {
                return ctx._propGet(object, key);
            },

            has(object, key) {
                return ctx._propHas(object, key);
            },

            set(object, key, value, receiver) {
                if (key === "length") {
                    const oldLength = object.length;

                    for (let i = value; i < oldLength; i++) {
                        if (i in object) {
                            ctx._propDelete(object, String(i));
                        }
                    }
                } else {
                    const keyInt = parseInt(key);

                    if (String(keyInt) === key && !isNaN(keyInt) && keyInt >= 0) {
                        const minLength = keyInt+1;

                        if (object.length < minLength) {
                            ctx._propSet(object, "length", minLength);
                        }
                    }
                }

                return ctx._propSet(object, key, value);
            },
        };
    }

    getWrapper(object) {
        if (this._wrapperObject.has(object)) {
            return object;
        }

        return this._objectWrapper.get(object) || this._createWrapper(object);
    }

    _createWrapper(object) {
        const handler = Array.isArray(object) ? this._arrayHandler : this._objectHandler;
        const wrapper = new Proxy(object, handler);
        this._objectWrapper.set(object, wrapper);
        this._wrapperObject.set(wrapper, object);
        return wrapper;
    }

    _propDelete(object, key) {
        const wrapper = this._objectWrapper.get(object);

        const oldValue = object[key];
        const oldValueWrapper = isObject(oldValue) ? this.getWrapper(oldValue) : oldValue;

        delete object[key];
        this._callbacks.delete(wrapper, key, oldValueWrapper);

        return true;
    }

    _propGet(object, key) {
        const value = object[key];
        return isObject(value) ? this.getWrapper(value) : value;
    }

    _propHas(object, key) {
        return key in object;
    }

    _propSet(object, key, newValue) {
        const wrapper = this._objectWrapper.get(object);

        const oldValuePlain = object[key];
        const oldValueWrapper = isObject(oldValuePlain) ? this.getWrapper(oldValuePlain) : oldValuePlain;

        let newValuePlain, newValueWrapper;
        if (isObject(newValue)) {
            if (this._wrapperObject.has(newValue)) {
                newValueWrapper = newValue;
                newValuePlain = this._wrapperObject.get(newValue);
            } else {
                newValuePlain = newValue;
                newValueWrapper = this.getWrapper(newValue);
            }
        } else {
            newValuePlain = newValue;
            newValueWrapper = newValue;
        }

        object[key] = newValuePlain;
        this._callbacks.set(wrapper, key, oldValueWrapper, newValueWrapper);

        return true;
    }
}

export default StructCallbackWrapperContext;
